<template>
    <div>


        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ item?.title }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                    <li class="ec-breadcrumb-item active">{{ item?.title }}</li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Ec About Us page -->
        <section class="ec-page-content section-space-p">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="section-title">
                            <h2 class="ec-bg-title">{{ item?.title }}</h2>
                        </div>
                    </div>
                    <div class="ec-common-wrapper">
                        <div class="row">

                            <div class="col-md-6 ec-cms-block ec-abcms-block text-center" v-if="item?.image != null">
                                <div class="ec-cms-block-inner">
                                    <img class="a-img" :src="item?.image" alt="about">
                                </div>
                            </div>

                            <div :class="{'col-md-6 ec-abcms-block' : item?.image != null}">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5>{{ $t('About us') }}</h5>
                                        <p class="">
                                            {{ main?.settings?.about }}
                                        </p>
                                    </div>
                                    <div class="col-md-12">
                                        <hr>
                                        <div v-html="item?.content"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import { useToast } from "vue-toastification";
import {useHead} from "@vueuse/head";
const toast = useToast();

export default {
    data() {
        return {
            item: [],
            main: [],
        }
    },
    methods:{
        async getMain() {
            await axios.get('main').then(response => {
                // toast.success("content loading...", {
                //     timeout: 2000
                // });
                this.main = response.data?.data;
                // this.currentLocale = response.data?.data?.lang;
                // this.$i18n.locale = this.currentLocale;
                // console.log(this.currentLocale);

            });
        }
    },
    async created() {

        const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});

        await axios.get(`pages/${this.$route.params.id}`, {}).then(response => {

            this.item = response.data.data;

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });

        await this.getMain();
        useHead({
            title: this.item?.title,
        })

    },
}
</script>
